var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentialFileManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59 22v-8c0-2.209-1.791-4-4-4h-26.528c-1.515 0-2.9-.856-3.578-2.211l-.789-1.578c-.678-1.355-2.063-2.211-3.578-2.211h-15.527c-2.209 0-4 1.791-4 4v20s57 0 57 0z",
    fill: "#69adfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54 27v-11c0-1.105-.895-2-2-2h-44c-1.105 0-2 .895-2 2v11z",
    fill: "#e8ecef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m59 22v30c0 2.209-1.791 4-4 4h-50c-2.209 0-4-1.791-4-4v-24c0-2.209 1.791-4 4-4h26.528c1.515 0 2.9-.856 3.578-2.211l.789-1.578c.678-1.355 2.063-2.211 3.578-2.211h15.528c2.209 0 4 1.791 4 4z",
    fill: "#8dd1fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentialFileManagement);
export default __webpack_public_path__ + "static/media/essential-file-management.e53166a0504406234ac987bbc97eed7f.svg";
export { ForwardRef as ReactComponent };